import logo from "./logo.svg";
import "./Game.css";
import React, { useEffect } from "react";
import { Buffer } from "buffer";
//import { ethers } from "ethers";

import { SiweMessage } from "siwe";
import Popup from "reactjs-popup";
import { useLocation, useNavigate, useParams } from "react-router-dom";
const ethers = require("ethers");

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();
    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}
const toHex = require("to-hex");

class Game extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVerified: false,
      walletCount: 0,
      nami: false,
      ccvault: false,
      gero: false,
      typhoon: false,
      flint: false,
      card: false,
      isLoading: true,
      canDoPayout: false,
      errormessage: "",
      signature: null,
      uid: null,
      paymentAddress: null,
      adaFee: null,
      selectedTokenCount: 0,
      ref: "",
    };
    // this.setVerified=this.setVerified.bind(this)
  }

  createSiweMessage = (address, statement) => {
    console.log({
      domain: this.state.domain,
      address,
      statement,
      uri: origin,
      version: "1",
      chainId: "0x89",
    });
    const message = new SiweMessage({
      domain: this.state.domain,
      address,
      statement,
      uri: origin,
      version: "1",
      chainId: "0x89",
    });
    return message.prepareMessage();
  };

  connectWallet = async (provider) => {
    await provider.send("eth_requestAccounts", []);
  };

  signInWithEthereum = async () => {
    try {
      this.setState({
        isLoading: true,
      });

      await window.ethereum.enable();
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      let network = await provider.getNetwork();
      console.log(network);
      if (network.chainId != "0x89") {
        await window.ethereum.request({
          method: "wallet_addEthereumChain",
          params: [
            {
              chainId: "0x89",
              rpcUrls: ["https://polygon-rpc.com/"],
              chainName: "Matic Mainnet",
              nativeCurrency: {
                name: "MATIC",
                symbol: "MATIC",
                decimals: 18,
              },
              blockExplorerUrls: ["https://polygonscan.com/"],
            },
          ],
        });
      }
      network = await provider.getNetwork();
      if (network.chainId != "0x89") {
        alert("Please switch to the Polygon Network");
        throw new Error("User did not switch the network");
      }
      const signer = await provider.getSigner();
      const address = await signer.getAddress();
      await this.connectWallet(provider);
      console.log("connected");
      const message = this.createSiweMessage(
        address,
        "Sign in with Ethereum to HHMC"
      );

      const signed = await signer.signMessage(message);

      try {
        const requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ref: this.state.ref,
            message: message,
            signature: signed,
          }),
        };
        let result;
        try {
          result = await fetch(
            "https://europe-west1-hhmc-d68d6.cloudfunctions.net/hhmc/verifyETH",
            requestOptions
          );
        } catch (error) {
          alert("Some networking error, please check your connection");
          return;
        }
        if (result.status >= 400 && result.status < 500) {
          alert(await result.text());
          return;
        }
        if (result.status >= 500 && result.status < 600) {
          alert(
            "An unknow error occured, please try again or contact the support"
          );
          return;
        }
        this.setVerified(
          ["ethAsset"],
          0,
          false,
          "Currently staking is not supported with ETH",
          "",
          ""
        );
      } catch (error) {
        alert(
          "An unknow error occured, please try again or contact the support"
        );
        return;
      }
      console.log(signed);
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };
  minPoints = 15000;
  setVerified = (assets, time, canDoPayout, message, signature, uid) => {
    this.setState({
      isVerified: true,
      count: assets.length,
      time: time,
      isLoading: false,
      canDoPayout: canDoPayout,
      errormessage: message,
      signature: signature,
      uid: uid,
      selectedTokenCount: Math.floor(
        this.secondsToPoints(this.state.time / 1000) / 100.0
      ),
    });
  };

  namiIsAvailable = () => {
    // @ts-ignore
    let res =
      typeof window.cardano !== "undefined" &&
      (typeof window.cardano.nami !== "undefined" ||
        typeof window.cardano.enable !== "undefined");
    if (res) {
      let state = this.state;
      this.setState({
        walletCount: state.walletCount + 1,
        nami: true,
        isLoading: false,
      });
    }
    return res;
  };

  namiIsConnected = async () => {
    if (await this.isAvailable()) {
      // @ts-ignore
      if (typeof window.cardano.nami !== "undefined") {
        // @ts-ignore
        return await window.cardano.nami.isEnabled();
      } else {
        console.debug(`Using legacy nami wallet integration`);

        // @ts-ignore
        return await window.cardano.isEnabled();
      }
    } else {
      return false;
    }
  };

  connectNami = async () => {
    // @ts-ignore
    if (typeof window.cardano.nami !== "undefined") {
      // @ts-ignore
      return await window.cardano.nami.enable();
    } else {
      console.debug(`Using legacy nami wallet integration`);

      // @ts-ignore
      await window.cardano.enable();

      // @ts-ignore
      return window.cardano;
    }
  };
  ccVaultIsAvailable = () => {
    // @ts-ignore
    let res =
      typeof window.cardano !== "undefined" &&
      typeof window.cardano.eternl !== "undefined";
    if (res) {
      let state = this.state;
      this.setState({
        walletCount: state.walletCount + 1,
        ccvault: true,
        isLoading: false,
      });
    }
    return res;
  };

  ccVaultIsConnected = async () => {
    // @ts-ignore

    return (
      (await this.isAvailable()) && (await window.cardano.eternl.isEnabled())
    );
  };

  connectCCVault = async () => {
    // @ts-ignore
    const cip30 = await window.cardano.eternl.enable();

    return cip30;
  };
  gerowalletisAvailable = () => {
    // @ts-ignore
    let res =
      typeof window.cardano !== "undefined" &&
      typeof window.cardano.gerowallet !== "undefined";
    if (res) {
      let state = this.state;
      this.setState({
        walletCount: state.walletCount + 1,
        gero: true,
        isLoading: false,
      });
    }
    return res;
  };

  gerowalletisConnected = async () => {
    // @ts-ignore
    return (
      (await this.isAvailable()) &&
      (await window.cardano.gerowallet.isEnabled())
    );
  };
  connectgerowallet = async () => {
    // @ts-ignore
    const cip30 = await window.cardano.gerowallet.enable();

    return cip30;
  };
  typhonisAvailable = () => {
    // @ts-ignore
    let res =
      typeof window.cardano !== "undefined" &&
      typeof window.cardano.typhon !== "undefined";
    if (res) {
      let state = this.state;
      this.setState({
        walletCount: state.walletCount + 1,
        typhoon: true,
        isLoading: false,
      });
    }
    return res;
  };

  typhonisConnected = async () => {
    // @ts-ignore
    if (await this.isAvailable()) {
      // @ts-ignore
      const isEnabledResponse = await window.cardano.typhon.isEnabled();

      return (
        isEnabledResponse.status === true && isEnabledResponse.data === true
      );
    }

    return false;
  };

  connecttyphon = async () => {
    // @ts-ignore
    const enableResponse = await window.cardano.typhon.enable();

    if (enableResponse.status === false || enableResponse.data === false) {
      throw new Error("Could not enabled Typhon Wallet");
    }

    // @ts-ignore
    return window.cardano.typhon;
  };
  flintIsAvailable = () => {
    // @ts-ignore
    let res =
      typeof window.cardano !== "undefined" &&
      typeof window.cardano.flint !== "undefined";
    if (res) {
      let state = this.state;
      this.setState({
        walletCount: state.walletCount + 1,
        flint: true,
        isLoading: false,
      });
    }
    return res;
  };

  flintIsConnected = async () => {
    // @ts-ignore
    return (
      (await this.isAvailable()) && (await window.cardano.flint.isEnabled())
    );
  };
  connectFlint = async () => {
    // @ts-ignore
    return await window.cardano.flint.enable();
  };
  cardWalletIsAvailable = () => {
    // @ts-ignore
    let res = typeof window.cardwallet !== "undefined";
    if (res) {
      let state = this.state;
      this.setState({
        walletCount: state.walletCount + 1,
        card: true,
        isLoading: false,
      });
    }
    return res;
  };

  cardWalletIsConnected = async () => {
    // @ts-ignore
    return (await this.isAvailable()) && (await window.cardwallet.isEnabled());
  };

  connectCardWallet = async () => {
    // @ts-ignore
    await window.cardwallet.enable();

    // @ts-ignore
    return window.cardwallet;
  };

  openCardWallet = async () => {
    let cardano = await this.connectCardWallet();
    this.open(cardano);
  };
  openFlint = async () => {
    let cardano = await this.connectFlint();
    this.open(cardano);
  };
  openTyphoon = async () => {
    let cardano = await this.connecttyphon();
    this.open(cardano);
  };
  openGero = async () => {
    let cardano = await this.connectgerowallet();
    this.open(cardano);
  };
  openNami = async () => {
    let cardano = await this.connectNami();
    this.open(cardano);
  };
  openCCVault = async () => {
    let cardano = await this.connectCCVault();
    this.open(cardano);
  };
  secondsToDhms(seconds) {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor((seconds % (3600 * 24)) / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? " hour " : " hours ") : "";
    var mDisplay = m + (m == 1 ? " minute " : " minutes ");
    var sDisplay = s + (s == 1 ? " second" : " seconds");
    return dDisplay + hDisplay + mDisplay + sDisplay;
  }
  secondsToPoints(seconds) {
    //2592000
    seconds = Number(seconds);
    return Math.floor(seconds * 0.00578703703);
  }
  NewlineText(props) {
    const text = props.text;
    const newText = text.split("\r\n").map((str) => <p>{str}</p>);

    return newText;
  }
  startPayout = async (tokens) => {
    const value = document.getElementById("payout").value;
    if (value < 150) {
      return;
    }
    this.setState({
      isLoading: true,
    });
    try {
      let requestOptions;
      if (this.state.signature.signature && this.state.signature.key) {
        requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            uid: this.state.uid,
            amount: value,
            signature: this.state.signature.signature,
            key: this.state.signature.key,
          }),
        };
      } else {
        requestOptions = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            uid: this.state.uid,
            amount: value,
            signature: this.state.signature,
          }),
        };
      }

      let result;
      try {
        result = await fetch(
          "https://europe-west1-hhmc-d68d6.cloudfunctions.net/hhmc/payout",
          requestOptions
        );
      } catch (error) {
        alert("Some networking error, please check your connection");
        return;
      }
      if (result.status >= 400 && result.status < 500) {
        alert(await result.text());
        return;
      }
      if (result.status >= 500 && result.status < 600) {
        alert(
          "An unknow error occured, please try again or contact the support"
        );
        return;
      }

      var response = await result.json();
      this.setState({
        adaFee: response.adaToPay,
        paymentAddress: response.paymentAddress,
      });
    } catch (error) {
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  open = async (cardano) => {
    try {
      this.setState({
        isLoading: true,
      });
      // getting address from which we will sign message
      const address = (await cardano.getUsedAddresses())[0];
      const network = await cardano.getNetworkId();
      console.log(address);
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          address: address,
          message:
            "Please verify your wallet to show you belong to the HHMC community ",
        }),
      };
      let result;
      try {
        result = await fetch(
          "https://europe-west1-hhmc-d68d6.cloudfunctions.net/hhmc/auth",
          requestOptions
        );
      } catch (error) {
        alert("Some networking error, please check your connection");
        return;
      }
      if (result.status >= 400 && result.status < 500) {
        alert(await result.text());
        return;
      }
      if (result.status >= 500 && result.status < 600) {
        alert(
          "An unknow error occured, please try again or contact the support"
        );
        return;
      }

      var response = await result.json();
      const messageToSign = Buffer.from(response.message, "utf8").toString(
        "hex"
      );
      console.log(response.message);
      let token;
      try {
        token = await cardano.signData(address, messageToSign);
      } catch (error) {
        return;
      }
      let requestOptions2;
      if (token.signature && token.key) {
        requestOptions2 = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            uid: response.uid,
            signature: token.signature,
            key: token.key,
            ref: this.state.ref,
          }),
        };
      } else {
        requestOptions2 = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            uid: response.uid,
            signature: token,
            ref: this.state.ref,
          }),
        };
      }
      let result2;
      try {
        result2 = await fetch(
          "https://europe-west1-hhmc-d68d6.cloudfunctions.net/hhmc/verify",
          requestOptions2
        );
      } catch (error) {
        alert("Some networking error, please check your connection");
        return;
      }
      if (result.status >= 400 && result.status < 500) {
        alert(await result.text());
        return;
      }
      if (result.status >= 500 && result.status < 600) {
        alert(
          "An unknow error occured, please try again or contact the support"
        );
        return;
      }
      var response2 = await result2.json();
      //(assets, time, canDoPayout, message, signature, uid)
      this.setVerified(
        response2.assetsCurrentlyStaking,
        response2.time,
        response2.canDoPayout,
        response2.message,
        token,
        response.uid
      );
    } catch (error) {
      alert("An unknow error occured, please try again or contact the support");
    } finally {
      this.setState({
        isLoading: false,
      });
    }
    /*const */
  };
  componentDidMount() {
    let uid = this.props.router.params.uid;

    window.Buffer = Buffer;
    this.setState({ ref: uid });
    window.addEventListener("load", async () => {
      const domain = window.location.host;
      const origin = window.location.origin;

      if (window.ethereum) {
        this.setState({
          domain,
          origin,
          metamask: true,
          walletCount: this.state.walletCount + 1,
        });
      } else {
        this.setState({ metamask: false });
      }

      this.ccVaultIsAvailable();
      this.namiIsAvailable();
      this.cardWalletIsAvailable();
      this.flintIsAvailable();
      this.typhonisAvailable();
      this.gerowalletisAvailable();
      this.setState({ isLoading: false });
    });
  }
  render() {
    if (this.state.ref.length < 5) {
      return (
        <div className="App min-h-screen mt-auto mb-auto flex flex-col justify-between">
          <div></div>
          <header className="App-header">
            <>
              <h2>Page not found</h2>
            </>
          </header>
          <footer className="mb-3 mt-12 flex justify-center p-3">
            <a
              className="text-base mr-2"
              href="https://hhmc.io/termsampconditionshhmc"
            >
              Terms & Conditions
            </a>
            <Popup
              trigger={
                <p className="button text-base ml-2 cursor-pointer"> Legal </p>
              }
              modal
              nested
            >
              {(close) => (
                <div className="bg-[#1b1e24] mx-20 p-5 max-h-[70vh] overflow-y-auto">
                  <div className="text-base mb-2">
                    {" "}
                    Introduction to HHMC staking program to earn TBC tokens{" "}
                  </div>
                  <div className="text-sm">
                    {" "}
                    HHMC NFT staking is a new way to earn native token TBC. It
                    lets HHMC NFT holders to keep their NFTs in their own wallet
                    and receive rewards for being a hodler. All without the need
                    to sell your NFT collection whilst keeping a full custody of
                    your NFT.
                    <br />
                    At the individual level, NFT staking can benefit collectors
                    as well as the developer team, as the overall supply tends
                    to be lower keeping the collectible price steady. But in a
                    broader context, NFT staking brings a new use case to NFTs
                    that go beyond the idea of collecting a digital art.
                    <br />
                    <br />
                    The minimum point to qualify for TBC token transfer into
                    collector’ own ADA wallet (such as Yoroi, Nami,
                    CCvault/Eternl and or Daedalus) is 50 TBC tokens as the
                    fungible token pay out is a new mint which incurs the
                    associated costs such as minting and gas fees (9 ADA is
                    required and 2 ADA received with TBC token). It is
                    recommended to keep the staking for longer than a month in
                    order to save on such costs. The associated cost is one off
                    should a collector requests for TBC token to be sent into
                    his/her wallet after 7 months period when the whole staking
                    TBC tokens should be distributed to HHMC NFT holders.
                    However it is NFT holder’ responsibility to ensure that
                    staking carried out manually and requesting for TBC token
                    transfer into collector’ own ADA wallet to be done before
                    the program finishes in 7 months’ time.
                    <br />
                    <br />
                    Once staked collector will be able to see the accumulated
                    points on a daily basis as this is recorded in our database.
                    Manual staking (linking your HHMC NFT wallet into our
                    staking webpage) should be carried out at least on a monthly
                    basis in order to qualify for a month worth of points.
                    <br />
                    <br />
                    <p className="inline italic text-sm">Disclaimer:</p> As this
                    is a beta staking program, HHMC team do not guarantee or
                    take responsibility that all the facilities of this program
                    will work flawlessly at the outset. However, we will
                    endeavour our best to deliver high quality user experience
                    as this is rolled out over a period of 3 months in beta. Any
                    loss of staking points and or staking period is not
                    reimbursed due to the volume of HHMC NFTs available for
                    staking and human hours that it takes to look into each such
                    query. Staking does not guarantee any monetary or
                    shareholding value besides native token TBC which will be
                    part of HHMC ecosystem.
                  </div>
                  <div className="actions mt-4">
                    <button
                      className="p-2"
                      onClick={() => {
                        close();
                      }}
                    >
                      close
                    </button>
                  </div>
                </div>
              )}
            </Popup>
          </footer>
        </div>
      );
    }
    if (this.state.isVerified) {
      return (
        <div className="App min-h-screen mt-auto mb-auto flex flex-col justify-between">
          <div></div>
          <header className="App-header">
            {this.state.isLoading ? (
              <div class="lds-dual-ring flex-shrink justify-center "></div>
            ) : (
              <>
                <h2>
                  {this.state.count >= 0
                    ? "You have been verified, close this window and return to the game"
                    : "You don't have any HHMC NFTs please buy either a coyote or a hyena to start playing"}
                </h2>
              </>
            )}
          </header>
          <footer className="mb-3 mt-12 flex justify-center p-3">
            <a
              className="text-base mr-2"
              href="https://hhmc.io/termsampconditionshhmc"
            >
              Terms & Conditions
            </a>
            <Popup
              trigger={
                <p className="button text-base ml-2 cursor-pointer"> Legal </p>
              }
              modal
              nested
            >
              {(close) => (
                <div className="bg-[#1b1e24] mx-20 p-5 max-h-[70vh] overflow-y-auto">
                  <div className="text-base mb-2">
                    {" "}
                    Introduction to HHMC staking program to earn TBC tokens{" "}
                  </div>
                  <div className="text-sm">
                    {" "}
                    HHMC NFT staking is a new way to earn native token TBC. It
                    lets HHMC NFT holders to keep their NFTs in their own wallet
                    and receive rewards for being a hodler. All without the need
                    to sell your NFT collection whilst keeping a full custody of
                    your NFT.
                    <br />
                    At the individual level, NFT staking can benefit collectors
                    as well as the developer team, as the overall supply tends
                    to be lower keeping the collectible price steady. But in a
                    broader context, NFT staking brings a new use case to NFTs
                    that go beyond the idea of collecting a digital art.
                    <br />
                    <br />
                    The minimum point to qualify for TBC token transfer into
                    collector’ own ADA wallet (such as Yoroi, Nami,
                    CCvault/Eternl and or Daedalus) is 50 TBC tokens as the
                    fungible token pay out is a new mint which incurs the
                    associated costs such as minting and gas fees (9 ADA is
                    required and 2 ADA received with TBC token). It is
                    recommended to keep the staking for longer than a month in
                    order to save on such costs. The associated cost is one off
                    should a collector requests for TBC token to be sent into
                    his/her wallet after 7 months period when the whole staking
                    TBC tokens should be distributed to HHMC NFT holders.
                    However it is NFT holder’ responsibility to ensure that
                    staking carried out manually and requesting for TBC token
                    transfer into collector’ own ADA wallet to be done before
                    the program finishes in 7 months’ time.
                    <br />
                    <br />
                    Once staked collector will be able to see the accumulated
                    points on a daily basis as this is recorded in our database.
                    Manual staking (linking your HHMC NFT wallet into our
                    staking webpage) should be carried out at least on a monthly
                    basis in order to qualify for a month worth of points.
                    <br />
                    <br />
                    <p className="inline italic text-sm">Disclaimer:</p> As this
                    is a beta staking program, HHMC team do not guarantee or
                    take responsibility that all the facilities of this program
                    will work flawlessly at the outset. However, we will
                    endeavour our best to deliver high quality user experience
                    as this is rolled out over a period of 3 months in beta. Any
                    loss of staking points and or staking period is not
                    reimbursed due to the volume of HHMC NFTs available for
                    staking and human hours that it takes to look into each such
                    query. Staking does not guarantee any monetary or
                    shareholding value besides native token TBC which will be
                    part of HHMC ecosystem.
                  </div>
                  <div className="actions mt-4">
                    <button
                      className="p-2"
                      onClick={() => {
                        close();
                      }}
                    >
                      close
                    </button>
                  </div>
                </div>
              )}
            </Popup>
          </footer>
        </div>
      );
    }
    return (
      <div className="App min-h-screen mt-auto mb-auto flex flex-col justify-between">
        <div></div>
        <header className="App-header">
          <p className="mx-3">
            To start playing the game please verify. Only do so if this page was
            opened by the game.
          </p>
          <p className="mt-3 text-base">
            This process is free and will not cost you any crypto
          </p>
          <p className="mt-5 text-base text-[#7ce5e8]">
            {" "}
            Please select the wallet where you have HHMC-NFTs. Click on SIGN in
            the following pop-up.
          </p>

          {this.state.isLoading ? (
            <div className="lds-dual-ring flex-shrink justify-center "></div>
          ) : (
            <div className="flex flex-col mt-5 mx-5">
              {this.state.gero && (
                <button onClick={this.openGero}> Gero</button>
              )}
              {this.state.nami && (
                <button onClick={this.openNami}> Nami</button>
              )}
              {this.state.flint && (
                <button onClick={this.openFlint}> Flint</button>
              )}
              {this.state.ccvault && (
                <button onClick={this.openCCVault}> Eternl</button>
              )}
              {this.state.typhoon && (
                <button onClick={this.openTyphoon}> Typhoon</button>
              )}
              {this.state.card && (
                <button onClick={this.openCardWallet}>CardWallet</button>
              )}
              {this.state.metamask && (
                <button onClick={this.signInWithEthereum}>Metamask</button>
              )}
              {this.state.walletCount == 0 && (
                <div>
                  <p className="text-base text-red-600">No Wallet detected!</p>
                  <p>
                    <br /> Have you enabled DApp support in your wallet
                    settings? <br /> If you are not sure if you have a wallet
                    please install one of the following wallets or their browser
                    extension:
                  </p>
                </div>
              )}
              <p className="text-base mb-2 mt-4">Not detected wallets</p>

              {!this.state.gero && (
                <button onClick={this.openGero} disabled>
                  Gero
                </button>
              )}
              {!this.state.nami && (
                <button onClick={this.openNami} disabled>
                  Nami
                </button>
              )}
              {!this.state.flint && (
                <button onClick={this.openFlint} disabled>
                  Flint
                </button>
              )}
              {!this.state.ccvault && (
                <button onClick={this.openCCVault} disabled>
                  Eternl
                </button>
              )}
              {!this.state.typhoon && (
                <button onClick={this.openTyphoon} disabled>
                  Typhoon
                </button>
              )}
              {!this.state.card && (
                <button onClick={this.openCardWallet} disabled>
                  CardWallet
                </button>
              )}
            </div>
          )}
        </header>
        <footer className="mb-3 mt-12 flex justify-center p-3">
          <a
            className="text-base mr-2"
            href="https://hhmc.io/termsampconditionshhmc"
          >
            Terms & Conditions
          </a>
          <Popup
            trigger={
              <p className="button text-base ml-2 cursor-pointer"> Legal </p>
            }
            modal
            nested
          >
            {(close) => (
              <div className="bg-[#1b1e24] mx-20 p-5 max-h-[70vh] overflow-y-auto">
                <div className="text-base mb-2">
                  {" "}
                  Introduction to HHMC staking program to earn TBC tokens{" "}
                </div>
                <div className="text-sm">
                  {" "}
                  HHMC NFT staking is a new way to earn native token TBC. It
                  lets HHMC NFT holders to keep their NFTs in their own wallet
                  and receive rewards for being a hodler. All without the need
                  to sell your NFT collection whilst keeping a full custody of
                  your NFT.
                  <br />
                  At the individual level, NFT staking can benefit collectors as
                  well as the developer team, as the overall supply tends to be
                  lower keeping the collectible price steady. But in a broader
                  context, NFT staking brings a new use case to NFTs that go
                  beyond the idea of collecting a digital art.
                  <br />
                  <br />
                  The minimum point to qualify for TBC token transfer into
                  collector’ own ADA wallet (such as Yoroi, Nami, CCvault/Eternl
                  and or Daedalus) is 50 TBC tokens as the fungible token pay
                  out is a new mint which incurs the associated costs such as
                  minting and gas fees (9 ADA is required and 2 ADA received
                  with TBC token). It is recommended to keep the staking for
                  longer than a month in order to save on such costs. The
                  associated cost is one off should a collector requests for TBC
                  token to be sent into his/her wallet after 7 months period
                  when the whole staking TBC tokens should be distributed to
                  HHMC NFT holders. However it is NFT holder’ responsibility to
                  ensure that staking carried out manually and requesting for
                  TBC token transfer into collector’ own ADA wallet to be done
                  before the program finishes in 7 months’ time.
                  <br />
                  <br />
                  Once staked collector will be able to see the accumulated
                  points on a daily basis as this is recorded in our database.
                  Manual staking (linking your HHMC NFT wallet into our staking
                  webpage) should be carried out at least on a monthly basis in
                  order to qualify for a month worth of points.
                  <br />
                  <br />
                  <p className="inline italic text-sm">Disclaimer:</p> As this
                  is a beta staking program, HHMC team do not guarantee or take
                  responsibility that all the facilities of this program will
                  work flawlessly at the outset. However, we will endeavour our
                  best to deliver high quality user experience as this is rolled
                  out over a period of 3 months in beta. Any loss of staking
                  points and or staking period is not reimbursed due to the
                  volume of HHMC NFTs available for staking and human hours that
                  it takes to look into each such query. Staking does not
                  guarantee any monetary or shareholding value besides native
                  token TBC which will be part of HHMC ecosystem.
                </div>
                <div className="actions mt-4">
                  <button
                    className="p-2"
                    onClick={() => {
                      close();
                    }}
                  >
                    close
                  </button>
                </div>
              </div>
            )}
          </Popup>
        </footer>
      </div>
    );
  }
}

export default withRouter(Game);
